import {getItemName, getPackageName} from "../../../shared/utils/basic";
import {Tag} from "antd";
import dayjs from "dayjs";
import React from "react";
import {Sorter} from "../../../shared/components/Sorter";

export const getPaymentLogColumns = (packageData, textList) => {
    return [
        {
            title: '상품 ID',
            dataIndex: 'productId',
            search: true,
        },
        {
            title: '아이템',
            dataIndex: 'itemId',
            render: (_, {itemId, productId}) => `${getPackageName(packageData, productId, itemId) || getItemName(textList, itemId, 8, productId)}`,
        },
        {
            title: '아이템 ID',
            dataIndex: 'itemId',
            search: true,
        },
        {
            title: '영수증 ID',
            dataIndex: 'orderId',
            search: true,
        },
        {
            title: '마켓',
            dataIndex: 'market',
            render: (_, {market, isSandbox}) => isSandbox ? `${market} (test)` : market,
            filters: [
                {
                    text: 'google',
                    value: 'google',
                },
                {
                    text: 'apple',
                    value: 'apple',
                },
            ],
            onFilter: (value, record) => record.market === value,
        },
        {
            title: '가격(USD)',
            dataIndex: 'price',
            render: (price) => `$${price?.toFixed(2)}`,
        },
        {
            title: '상태',
            dataIndex: 'isRefund',
            render: (isRefund) => <Tag color={isRefund ? 'red' : 'green'}>{isRefund ? '환불' : '구매'}</Tag>,
            filters: [
                {
                    text: '환불',
                    value: 1,
                },
                {
                    text: '구매',
                    value: 0,
                },
            ],
        },
        {
            title: '구매 시각',
            dataIndex: 'created',
            render: (time) => dayjs(time).format('YYYY-MM-DD HH:mm:ss'),
            sorter: (a, b) => Sorter.DATE(a.time, b.time),
        },
    ]
};